import { get, post } from "./base-api"

//Register Team
export const register = (data)=> {
    return post('team',data);
}

//Email Subscribe
export const subscribeEmail = (email)=> {
    return get(`subscribe/${email}`);
}

//Ask a question
export const askQuestion = (data)=> {
    return post('question',data);
}

//Fetch Locations
export const getLocations = () => {
    return get(`locations`);
}

//Fetch Leaderboard Data
export const getLeaderboard = () => {
   return get(`leaderboard`);
}
